import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Dcs0101Service } from "../../../../services/dcs/Dcs0101Service";
import { Constant } from "../../../../constants/constant";
import AppPagination from "../../../../components/commons/AppPagination";
import moment from "moment";
import AppDatePicker from "../../../../components/commons/AppDatePicker";
import { useDispatch } from "react-redux";
import { showAndHideSpinner } from "../../../../reducers/spinnerSlice";
import { toast } from "react-toastify";
import { Dropdown } from "primereact/dropdown";

export class Dcs0101DataSearch {
  tableNm?: any;
  dataMapId?: any;
  page: number;
  size: number;
  startDt: any;
  endDt: any;
  time: any;
  constructor(tableNm: string, dataMapId: number, page: number, size: number, startDt: any, endDt: any, time: any) {
    this.tableNm = tableNm;
    this.dataMapId = dataMapId;
    this.page = page;
    this.size = size;
    this.startDt = startDt;
    this.endDt = endDt;
    this.time = time;
  }
}
export default function Dcs0101ViewData(props: any) {
  const [data, setData] = useState<any>([]);
  const { t, i18n } = useTranslation();
  const [modelSearch, setModelSearch] = useState<Dcs0101DataSearch>(new Dcs0101DataSearch(props.tableNm, props.dataMapId, 1, Constant.ROWS_OF_PAGE, "", "", new Date().getTime()));
  const totalPage = useRef(1);
  const [dataMap, setDataMap] = useState<any>([]);
  const [startDt, setStartDt] = useState<any>();
  const [endDt, setEndDt] = useState<any>();
  const dispatch = useDispatch();
  const [colFilter, setColFilter] = useState<any>([]);

  useEffect(() => {
    getData();
  }, [modelSearch.page, modelSearch.startDt, modelSearch.endDt, modelSearch.time, modelSearch.size]);

  useEffect(() => {
    getDataMapDetail();
  }, []);

  const getData = () => {
    dispatch(showAndHideSpinner(true));
    Dcs0101Service.getInstance()
      .getDataByConnectionNm(modelSearch)
      .finally(() => {
        dispatch(showAndHideSpinner(false));
      })
      .then((res: any) => {
        if (res.data.status) {
          setData(res.data.responseData.data);
          totalPage.current = res.data.responseData.count;
        }
      })
      .catch((err: any) => {});
  };

  const getDataMapDetail = () => {
    Dcs0101Service.getInstance()
      .getDataMapDetail({ connectionId: props.connectionId })
      .then((res: any) => {
        if (res.data.status) {
          setDataMap(res.data.responseData);
        }
      })
      .catch((err: any) => {});
  };

  const changePage = (page: number) => {
    setModelSearch({
      ...modelSearch,
      page: page,
    });
  };

  const handleChangeStartDt = (event: any) => {
    let startDt = new Date(event);
    setStartDt(event);
    setModelSearch({ ...modelSearch, startDt: startDt.toISOString(), page: 1 });
  };

  const handleChangeEndDt = (event: any) => {
    let endDt = new Date(event);
    setEndDt(event);
    setModelSearch({ ...modelSearch, endDt: endDt.toISOString(), page: 1 });
  };

  const search = () => {};

  const reset = () => {
    setStartDt("");
    setEndDt("");
    setModelSearch({ ...modelSearch, startDt: "", endDt: "", time: new Date().getTime() });
  };

  const exportData = () => {
    dispatch(showAndHideSpinner(true));
    Dcs0101Service.getInstance()
      .exportData(modelSearch)
      .then(() => {
        toast.success(`${t("dcs0101.message.success.exportData")}`);
      })
      .catch(() => {
        toast.error(`${t("dcs0101.message.error.exportData")}`);
      })
      .finally(() => {
        dispatch(showAndHideSpinner(false));
      });
  };

  const handleSelectFilterCol = (event: any) => {
    if (event.target.checked) {
      setColFilter((prev: any) => {
        return [...prev, event.target.value];
      });
    } else {
      setColFilter((prev: any) => {
        return prev.filter((ele: any) => ele !== event.target.value);
      });
    }
  };

  const handleChangeRowOfPage = (data: any) => {
    setModelSearch({ ...modelSearch, size: data });
  };

  return (
    <>
      <div className="search-box mb-3">
        <div className="row mb-3 align-items-end">
          <div className="col-xl-10">
            <div className="row align-items-center">
              <div className="col-xl-2">
                {/* <label className="form-label"> {t("dcs0101.label.startDt")}</label> */}
                <label className="fs-6 fw-600">{t("dcs0101.label.stDtToEndDt")}</label>
              </div>
              <div className="col-xl-10 p-0">
                <div className="row">
                  <div className="col-xl-3">
                    <AppDatePicker onChange={handleChangeStartDt} maxDate={endDt} value={startDt || ""} showTime={true} />
                  </div>
                  <div className="col-xl-3 d-flex align-items-center">
                    <input type="number" className="form-control" placeholder="5,000" />
                    <span className="ms-3">~</span>
                  </div>
                  <div className="col-xl-3">
                    <AppDatePicker onChange={handleChangeEndDt} minDate={startDt} value={endDt || ""} showTime={true} />
                  </div>
                  <div className="col-xl-3">
                    <input type="number" className="form-control" placeholder="5,000" />
                  </div>
                </div>
                {/* <AppDatePicker onChange={handleChangeStartDt} maxDate={endDt} value={startDt || ""} showTime={true} />
                ~
                <AppDatePicker onChange={handleChangeEndDt} minDate={startDt} value={endDt || ""} showTime={true} /> */}
              </div>
            </div>
          </div>
          <div className="col-xl-2 area-btn-search d-flex gap-2 justify-content-end">
            <button type="button" className="custom-btn gradient" onClick={search}>
              <i className="pi pi-search fs-16 me-2"></i> {t("sample.label.search")}
            </button>
            <button type="button" className="custom-btn" onClick={reset}>
              <i className="pi pi-refresh fs-16 me-2"></i> {t("sys0301.label.reset")}
            </button>
          </div>
        </div>

        <div className="row align-items-center">
          <div className="col-xl-10">
            <div className="row align-items-center">
              <div className="search-el col-xl-2">
                <label className="fs-6 fw-600">{t("dcs0101.label.selectFilter")}</label>
              </div>
              <div className="search-el search-filter col-xl-10">
                <div className="d-flex gap-5">
                  {dataMap.map((ele: any, index: any) => (
                    <div key={index} className="checkbox-radio">
                      <input
                        type="checkbox"
                        className="filled-in chk-col-primary"
                        name="col-name"
                        checked={colFilter.includes(ele.colNm)}
                        id={`col-name-${index}`}
                        value={ele.colNm}
                        onChange={handleSelectFilterCol}
                      />
                      <label htmlFor={`col-name-${index}`}>{ele.colNm}</label>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-2 area-btn-search d-flex gap-2 justify-content-end">
            {/* <button type="button" className="custom-btn btn-success" onClick={exportData}>
              <i className="pi pi-file-excel fs-16 me-2"></i> {t("common.button.label.export")}
            </button> */}
            <button className="custom-btn" onClick={exportData}>
              <img style={{ width: "17px" }} src={require("../../../../../assets/images/icon/excel.png")} />
              {t("common.button.label.downloadExcel")}
            </button>
          </div>
        </div>
      </div>

      <div className="d-flex justify-content-end mb-3">
        <Dropdown value={modelSearch.size} onChange={(e: any) => handleChangeRowOfPage(e.value)} options={Constant.LST_ROW_OF_PAGE} style={{ minWidth: "100px" }} />
      </div>

      <div className="tbl-st scroll-x">
        <table>
          <thead>
            <tr>
              <th>{t("dcs0101.table.header.time")}</th>
              {dataMap.map((ele: any, index: number) => (
                <>
                  {(colFilter.length === 0 || colFilter.includes(ele.colNm)) && (
                    <th key={index} scope="col">
                      {ele.colNm}
                    </th>
                  )}
                </>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((element: any, index: number) => (
              <tr key={index}>
                <td className="text-start">{moment(element.created_dt).format("MM/DD/YYYY, h:mm:ss a")}</td>
                {dataMap.map((ele: any, index: number) => (
                  <>{(colFilter.length === 0 || colFilter.includes(ele.colNm)) && <td key={index}>{element[ele.colNm]}</td>}</>
                ))}
              </tr>
            ))}
            {data.length === 0 && (
              <tr className="text-center">
                <td colSpan={dataMap.length + 1}>{t("common.table.noData")}</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <div className="d-flex justify-content-center">{data.length > 0 && <AppPagination page={modelSearch.page} rows={Constant.ROWS_OF_PAGE} onChange={changePage} count={totalPage.current} />}</div>
    </>
  );
}
